export default __webpack_public_path__ + "static/media/approach.33dfdc99.svg";